/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPolygon8 = (props: Props) => (
  <Icon viewBox="0 0 8 8" {...props}>
    <path d="M1.582 0 0 4l1.582 4h4.836L8 4 6.418 0z" fill="currentcolor" fillRule="evenodd" />
  </Icon>
);
export { SvgPolygon8 as Polygon8 };
